import { render } from "./AdminLoginLayer.vue?vue&type=template&id=c74297b4&ts=true"
import script from "./AdminLoginLayer.vue?vue&type=script&lang=ts"
export * from "./AdminLoginLayer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__